import { Component, Input, OnInit, EventEmitter, Output, OnChanges } from '@angular/core';
import { Rule } from '../../models/flow.dto';
import { RuleBuilderService } from '../../../builder/services/rule-builder.service';
import { genId } from '../../../core/services/genId';
import { LunaCodeNode } from '../../models/rules.model';

@Component({
    selector: 'rules-editor',
    templateUrl: './rules-editor.component.html',
    styleUrls: ['./rules-editor.component.scss'],
    standalone: false
})
export class RulesEditorComponent implements OnInit, OnChanges {
    @Input() placeholder: string = "";
   
    @Input() rule: Rule;

    @Input() set expression(value: string) {
        if (value === undefined || value === null) {
            value = "";
        }
        if (!this.rule) {
            this.rule = {
                name: this.type,
                expression: value,
                ruleId: genId()
            } as Rule;
        } else {
            this.rule.expression = value;
        }
    }

    @Input() type: string;

    @Output() updateRule: EventEmitter<Rule> = new EventEmitter<Rule>();
    @Output() compileSuccess: EventEmitter<boolean> = new EventEmitter<boolean>();

    public compileSuccessful: boolean = false;
    public canValidateExpression: boolean = true;
    public validationMessage: string = '';
    public _compileSuccessfulMessage: string = 'Expression compiles successfully.';
    public _compileFailedMessage: string = 'Expression does not compile.';
    public _notYetValidated: string = 'Expression has not been evaluated';

    constructor(public readonly _service: RuleBuilderService) { }

    public ngOnChanges(changes): void {
        if (!this.rule) {
            this.rule = {
                name: this.type,
                expression: "",
                ruleId: genId()
            } as Rule;
        }
    }

    ngOnInit() {
        
    }

    public testExpression(): void {
        this.canValidateExpression = false;
        const exprService = this._service.compileExpression(this.rule.expression);
        exprService.subscribe(expResult => {
            this.compileSuccessful = true;
            this.validationMessage = this._compileSuccessfulMessage;
            this.rule.parseTree = expResult;
            if (!this.rule.ruleId || this.rule.ruleId === "") {
                this.rule.ruleId == genId();
            }
            this.updateRule.emit(this.rule);
            this.compileSuccess.emit(this.compileSuccessful);
        },
            (error) => {                
                this.compileSuccessful = false;
                this.updateRule.emit(null);
                this.compileSuccess.emit(this.compileSuccessful);
                this.validationMessage = this._compileFailedMessage;
            },
            () => this.canValidateExpression = true);
    }

    public invalidateExpression(): void {
        this.compileSuccessful = false;
        this.compileSuccess.emit(this.compileSuccessful);
        this.canValidateExpression = true;
        this.validationMessage = this._notYetValidated;
    }
}
